import React, { useState, useEffect, useMemo } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Logo from "../common/components/LogoComponent.jsx";
// [DISABLED] agent status badge
// import {
//     STATUS_ERRORS,
//     STATUS_STRINGS,
// } from "../common/constants/agentModule/statusConstants.js";
import {
    VARIANTS,
    BUTTON_COLORS,
    SIZES,
} from "../common/constants/commonConstants.js";
// [DISABLED] agent status badge — dropdown arrows only used by the status button
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import {
    Box,
    Button,
    Typography,
    Avatar,
    Tooltip,
    List,
    ListItem,
    Menu,
    MenuItem,
    IconButton,
    Divider,
} from "@mui/material";
import {
    // --- legacy keys retained so any unmigrated menu row still renders ---
    SpeedRounded as SpeedRoundedIcon,
    People as PeopleIcon,
    UploadFile as UploadFileIcon,
    DataUsage as DataUsageIcon,
    Chat as ChatIcon,
    Payment as PaymentIcon,
    QuestionAnswerOutlined as QuestionAnswerOutlinedIcon,
    Campaign as CampaignIcon,
    Settings as SettingsIcon,
    MarkEmailUnreadOutlined as MarkEmailUnreadOutlinedIcon,
    Portrait as PortraitIcon,
    HeadsetMicOutlined,
    Textsms,
    PhoneInTalk as PhoneInTalkIcon,
    Voicemail as VoicemailIcon,
    CallReceived as CallReceivedIcon,
    SpaceDashboard as SpaceDashboardIcon,
    ViewQuilt as ViewQuiltIcon,
    SupervisorAccount as SupervisorAccountIcon,
    AdminPanelSettings as AdminPanelSettingsIcon,
    Forum as ForumIcon,
    ChatBubbleOutline as ChatBubbleOutlineIcon,
    DonutLarge as DonutLargeIcon,
    Sms as SmsIcon,
    Message as MessageIcon,
    TrackChanges as TrackChangesIcon,
    TrendingUp as TrendingUpIcon,
    Storage as StorageIcon,
    LockOpen as LockOpenIcon,
    Badge as BadgeIcon,
    Psychology as PsychologyIcon,
    Group as GroupIcon,
    SupervisedUserCircle as SupervisedUserCircleIcon,
    Policy as PolicyIcon,
    AddToQueue as AddToQueueIcon,
    Engineering as EngineeringIcon,
    AssignmentInd as AssignmentIndIcon,
    AssignmentTurnedIn as AssignmentTurnedInIcon,
    Home as HomeIcon,
    House as HouseIcon,
    Schedule as ScheduleIcon,
    Send as SendIcon,
    Email as EmailIcon,
    Handshake as HandshakeIcon,
    IntegrationInstructions as IntegrationInstructionsIcon,
    LocalPhone as LocalPhoneIcon,
    AssuredWorkload as AssuredWorkloadIcon,
    PersonSearch as PersonSearchIcon,
    AssignmentReturned as AssignmentReturnedIcon,
    PeopleAlt as PeopleAltIcon,
    Search as SearchIcon,
    Flaky as FlakyIcon,
    Language as LanguageIcon,
    AccessAlarm as AccessAlarmIcon,
    // --- added so every menu row can carry a distinct glyph ---
    Dashboard as DashboardIcon,
    Paid as PaidIcon,
    CreditCard as CreditCardIcon,
    PhoneCallback as PhoneCallbackIcon,
    PhoneForwarded as PhoneForwardedIcon,
    TrendingDown as TrendingDownIcon,
    FactCheck as FactCheckIcon,
    ManageAccounts as ManageAccountsIcon,
    CalendarMonth as CalendarMonthIcon,
    AddComment as AddCommentIcon,
    WavingHand as WavingHandIcon,
    Gavel as GavelIcon,
    Unsubscribe as UnsubscribeIcon,
    EventBusy as EventBusyIcon,
    SwapHoriz as SwapHorizIcon,
    CallSplit as CallSplitIcon,
    ExitToApp as ExitToAppIcon,
    Percent as PercentIcon,
    Insights as InsightsIcon,
    Groups as GroupsIcon,
    ThumbUpAlt as ThumbUpAltIcon,
    SentimentSatisfiedAlt as SentimentSatisfiedAltIcon,
    Scoreboard as ScoreboardIcon,
    EmojiEmotions as EmojiEmotionsIcon,
    SettingsSuggest as SettingsSuggestIcon,
    TaskAlt as TaskAltIcon,
    NotificationsActive as NotificationsActiveIcon,
    Block as BlockIcon,
    BarChart as BarChartIcon,
    ListAlt as ListAltIcon,
    ModelTraining as ModelTrainingIcon,
    GridOn as GridOnIcon,
    Summarize as SummarizeIcon,
    Tune as TuneIcon,
    MonitorHeart as MonitorHeartIcon,
} from "@mui/icons-material";

import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { getmenuitems, savePageVisits } from "../services/api";
import { useTheme } from "@mui/material/styles";
// [DISABLED] agent status badge
// import { getAgentCurrentStatus } from "../services/agentModule/status/statusServices.js";
// import { useAgentStatus } from "../providers/AgentStatusContext.jsx";
import CFNavigationButton from "./core/CFNavigationButton";
// [DISABLED] backlog status bar
// import { getBacklog } from "../services/logsModule/calllogsServices.js";

/**
 * Icon mapping from the string key stored in menuitems.menuicon to a component.
 *
 * Keys are grouped: the first block is the original set (kept so a menu row that
 * has not been migrated still renders something), the second block is the set
 * added to give each page its own glyph. A key that is missing here renders as
 * no icon at all, which is silent in production — see the dev warning in
 * buildMenuTree below.
 */
const iconMapping = {
    // legacy keys
    SpeedRoundedIcon: <SpeedRoundedIcon />,
    PeopleIcon: <PeopleIcon />,
    UploadFileIcon: <UploadFileIcon />,
    DataUsageIcon: <DataUsageIcon />,
    ChatIcon: <ChatIcon />,
    PaymentIcon: <PaymentIcon />,
    QuestionAnswerOutlinedIcon: <QuestionAnswerOutlinedIcon />,
    CampaignIcon: <CampaignIcon />,
    SettingsIcon: <SettingsIcon />,
    MarkEmailUnreadOutlinedIcon: <MarkEmailUnreadOutlinedIcon />,
    PortraitIcon: <PortraitIcon />,
    HeadsetMicOutlined: <HeadsetMicOutlined />,
    Textsms: <Textsms />,
    PhoneInTalkIcon: <PhoneInTalkIcon />,
    VoicemailIcon: <VoicemailIcon />,
    CallReceivedIcon: <CallReceivedIcon />,
    SpaceDashboardIcon: <SpaceDashboardIcon />,
    ViewQuiltIcon: <ViewQuiltIcon />,
    SupervisorAccountIcon: <SupervisorAccountIcon />,
    AdminPanelSettingsIcon: <AdminPanelSettingsIcon />,
    ForumIcon: <ForumIcon />,
    ChatBubbleOutlineIcon: <ChatBubbleOutlineIcon />,
    DonutLargeIcon: <DonutLargeIcon />,
    SmsIcon: <SmsIcon />,
    MessageIcon: <MessageIcon />,
    TrackChangesIcon: <TrackChangesIcon />,
    TrendingUpIcon: <TrendingUpIcon />,
    StorageIcon: <StorageIcon />,
    LockOpenIcon: <LockOpenIcon />,
    BadgeIcon: <BadgeIcon />,
    PsychologyIcon: <PsychologyIcon />,
    GroupIcon: <GroupIcon />,
    SupervisedUserCircleIcon: <SupervisedUserCircleIcon />,
    PolicyIcon: <PolicyIcon />,
    EngineeringIcon: <EngineeringIcon />,
    AddToQueueIcon: <AddToQueueIcon />,
    AssignmentIndIcon: <AssignmentIndIcon />,
    AssignmentTurnedInIcon: <AssignmentTurnedInIcon />,
    HomeIcon: <HomeIcon />,
    HouseIcon: <HouseIcon />,
    ScheduleIcon: <ScheduleIcon />,
    SendIcon: <SendIcon />,
    SearchIcon: <SearchIcon />,
    FlakyIcon: <FlakyIcon />,
    HandshakeIcon: <HandshakeIcon />,
    LanguageIcon: <LanguageIcon />,
    AccessAlarmIcon: <AccessAlarmIcon />,
    EmailIcon: <EmailIcon />,
    IntegrationInstructionsIcon: <IntegrationInstructionsIcon />,
    LocalPhoneIcon: <LocalPhoneIcon />,
    AssuredWorkloadIcon: <AssuredWorkloadIcon />,
    PersonSearchIcon: <PersonSearchIcon />,
    AssignmentReturnedIcon: <AssignmentReturnedIcon />,
    PeopleAltIcon: <PeopleAltIcon />,

    // added keys
    DashboardIcon: <DashboardIcon />,
    PaidIcon: <PaidIcon />,
    CreditCardIcon: <CreditCardIcon />,
    PhoneCallbackIcon: <PhoneCallbackIcon />,
    PhoneForwardedIcon: <PhoneForwardedIcon />,
    TrendingDownIcon: <TrendingDownIcon />,
    FactCheckIcon: <FactCheckIcon />,
    ManageAccountsIcon: <ManageAccountsIcon />,
    CalendarMonthIcon: <CalendarMonthIcon />,
    AddCommentIcon: <AddCommentIcon />,
    WavingHandIcon: <WavingHandIcon />,
    GavelIcon: <GavelIcon />,
    UnsubscribeIcon: <UnsubscribeIcon />,
    EventBusyIcon: <EventBusyIcon />,
    SwapHorizIcon: <SwapHorizIcon />,
    CallSplitIcon: <CallSplitIcon />,
    ExitToAppIcon: <ExitToAppIcon />,
    PercentIcon: <PercentIcon />,
    InsightsIcon: <InsightsIcon />,
    GroupsIcon: <GroupsIcon />,
    ThumbUpAltIcon: <ThumbUpAltIcon />,
    SentimentSatisfiedAltIcon: <SentimentSatisfiedAltIcon />,
    ScoreboardIcon: <ScoreboardIcon />,
    EmojiEmotionsIcon: <EmojiEmotionsIcon />,
    SettingsSuggestIcon: <SettingsSuggestIcon />,
    TaskAltIcon: <TaskAltIcon />,
    NotificationsActiveIcon: <NotificationsActiveIcon />,
    BlockIcon: <BlockIcon />,
    BarChartIcon: <BarChartIcon />,
    ListAltIcon: <ListAltIcon />,
    ModelTrainingIcon: <ModelTrainingIcon />,
    GridOnIcon: <GridOnIcon />,
    SummarizeIcon: <SummarizeIcon />,
    TuneIcon: <TuneIcon />,
    MonitorHeartIcon: <MonitorHeartIcon />,
};

/**
 * Collect every root-to-node chain whose leaf `path` matches `pathname`.
 * A parent commonly points at the same route as its default landing child,
 * so more than one chain can match a single URL.
 */
const collectMatchingTrails = (items, pathname, trail = []) => {
    let matches = [];
    for (const item of items) {
        const nextTrail = [...trail, item];
        if (item.path && item.path === pathname) {
            matches.push(nextTrail);
        }
        if (item.children && item.children.length > 0) {
            matches = matches.concat(
                collectMatchingTrails(item.children, pathname, nextTrail)
            );
        }
    }
    return matches;
};

/**
 * Resolve the chain of nodes from the root down to the active node.
 *
 * Matching on path rather than name avoids collisions between two menu rows
 * that happen to share a label, and lets a deep link resolve its ancestors.
 *
 * When several rows share the route, the DEEPEST chain wins. That is what makes
 * a parent's default landing child pick up the full selected treatment while
 * the parent itself falls back to the lighter active-group state.
 */
const findActiveTrail = (items, pathname) => {
    const matches = collectMatchingTrails(items, pathname);
    if (!matches.length) return null;
    return matches.reduce((deepest, candidate) =>
        candidate.length > deepest.length ? candidate : deepest
    );
};

// [DISABLED] Backlog polling — was driving the Active Agents/Texts/Emails/...
// status bar in the toolbar. Hook + getBacklog call disabled until needed again.
//
// export function useBacklogPolling(intervalMs = 45000) {
//     const [data, setData] = React.useState({
//         agents: 0,
//         texts: 0,
//         emails: 0,
//         chats: 0,
//         vms: 0,
//         calls: 0,
//         carachats: 0,
//     });
//
//     const load = React.useCallback(async () => {
//         try {
//             const resp = await getBacklog(); // expects { agents, texts, emails, ... }
//             setData((prev) => ({ ...prev, ...resp })); // keep defaults for fields not returned yet
//         } catch (e) {
//             console.error("Backlog poll error:", e);
//         }
//     }, []);
//
//     React.useEffect(() => {
//         load();
//         const id = setInterval(load, intervalMs);
//         return () => clearInterval(id);
//     }, [load, intervalMs]);
//
//     return { data, refresh: load };
// }

const Layout = ({ companyName, setAllowedPaths }) => {
    // [DISABLED] agent status context
    // const { refreshTrigger } = useAgentStatus();
    const { instance, accounts } = useMsal();

    const [isNavigationExpanded, setIsNavigationExpanded] = useState(() => {
        const savedState = localStorage.getItem("isNavigationExpanded");
        return savedState ? JSON.parse(savedState) : true;
    });

    const [menuItems, setMenuItems] = useState([]); // hierarchical menu tree
    const [userInitials, setUserInitials] = useState("");
    const [expandedParents, setExpandedParents] = useState(null); // id of the single expanded parent
    const location = useLocation();
    // [DISABLED] backlog polling — see useBacklogPolling above
    // const { data: backlog } = useBacklogPolling(45000);

    // --- New state for avatar menu ---
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleAvatarClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {
        try {
            await trackMenuClick("LoggedOut", "/");
        } catch (e) {
            console.error("Logout tracking failed:", e);
        } finally {
            localStorage.removeItem("user");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("usermenu");
            localStorage.setItem("justLoggedIn", "false");
            instance.logoutPopup();
            handleCloseMenu();
        }
    };
    // -----------------------------

    const account = accounts && accounts.length > 0 ? accounts[0] : null;
    //const email = account?.username;

    const [userId, setUserId] = useState("");
    // [DISABLED] agent status badge — state, fetch, timer all turned off below
    // const [agentStatusInfo, setAgentStatusInfo] = useState([]);
    // const [loadingAgentStatus, setLoadingAgentStatus] = useState(true);
    // const [statusMenu, setStatusMenu] = useState(false);
    // const [statusTime, setStatusTime] = useState("");
    const justLoggedIn = localStorage.getItem("justLoggedIn");

    // [DISABLED] agent status fetch
    // useEffect(() => {
    //     if (userId) {
    //         fetchAgentStatus();
    //     }
    // }, [refreshTrigger, userId]);
    //
    // const fetchAgentStatus = async () => {
    //     try {
    //         setLoadingAgentStatus(true);
    //         const statusData = await getAgentCurrentStatus(userId);
    //         setAgentStatusInfo(statusData);
    //     } catch (error) {
    //         console.error(STATUS_ERRORS.FETCH_AGENT_STATUS_ERROR, error);
    //     } finally {
    //         setLoadingAgentStatus(false);
    //     }
    // };

    // Build hierarchical tree from flat data using parentid
    const buildMenuTree = (flatMenu) => {
        const map = {};
        flatMenu.forEach((item) => {
            // A menuicon value with no entry in iconMapping renders as nothing at
            // all, which is invisible in prod. Warn in dev so a newly added menu
            // row missing its mapping is caught immediately.
            if (
                process.env.NODE_ENV !== "production" &&
                item.icon &&
                !iconMapping[item.icon]
            ) {
                console.warn(
                    `Unmapped menu icon "${item.icon}" on menu item "${item.name}" (id ${item.id})`
                );
            }
            map[item.id] = {
                ...item,
                icon: iconMapping[item.icon] || null,
                children: [],
            };
        });

        const tree = [];
        flatMenu.forEach((item) => {
            if (item.parentid && item.parentid !== 0 && map[item.parentid]) {
                map[item.parentid].children.push(map[item.id]);
            } else {
                tree.push(map[item.id]);
            }
        });
        return tree;
    };

    const fetchMenuItems = async () => {
        if (!account) {
            console.log("No logged in account");
            return;
        }

        try {
            const tokenResponse = await instance.acquireTokenSilent({
                ...loginRequest,
                account: account,
            });

            const accessToken = tokenResponse.accessToken;

            if (!accessToken) throw new Error("Access token is required");

            const userMenu = await getmenuitems(accessToken);

            if (userMenu) {
                setUserId(userMenu.id);
            }

            if (userMenu && userMenu.firstname && userMenu.lastname) {
                const initials = `${userMenu.firstname.charAt(
                    0
                )}${userMenu.lastname.charAt(0)}`.toUpperCase();
                setUserInitials(initials);
            }

            const formattedFlatMenu = userMenu.usermenu.map((item) => ({
                id: item.menuorderid,
                name: item.menuname,
                icon: item.menuicon || null,
                path: item.menupath,
                parentid: item.parentid,
            }));

            const menuTree = buildMenuTree(formattedFlatMenu);
            setMenuItems(menuTree);
        } catch (error) {
            console.error("Error fetching menu items", error);
        }
    };

    useEffect(() => {
        fetchMenuItems();
    }, [account]);

    useEffect(() => {
        localStorage.setItem(
            "isNavigationExpanded",
            JSON.stringify(isNavigationExpanded)
        );
    }, [isNavigationExpanded]);

    // Resolve the active node and its ancestors from the URL. This is the single
    // source of truth for both the sidebar highlight and the toolbar breadcrumb,
    // so a hard refresh or a deep link lands in the correct state.
    const activeTrail = useMemo(() => {
        if (!menuItems.length) return [];
        return findActiveTrail(menuItems, location.pathname) || [];
    }, [menuItems, location.pathname]);

    const activeNode = activeTrail.length
        ? activeTrail[activeTrail.length - 1]
        : null;
    const activeIds = useMemo(
        () => activeTrail.map((node) => node.id),
        [activeTrail]
    );

    // Auto-expand the group that contains the active route. Only runs when the
    // route or the menu changes, so manually toggling a different group open
    // is not fought by this effect.
    useEffect(() => {
        if (activeTrail.length > 1) {
            setExpandedParents(activeTrail[activeTrail.length - 2].id);
        } else if (
            activeNode &&
            activeNode.children &&
            activeNode.children.length > 0
        ) {
            setExpandedParents(activeNode.id);
        }
        // A top-level leaf leaves the current expansion untouched.
    }, [activeTrail]);

    // [DISABLED] agent status timer (was driving the "Offline (HH:MM:SS)" counter)
    // useEffect(() => {
    //     if (!agentStatusInfo?.statusDate) return;
    //
    //     const updateTimer = () => {
    //         const statusDate = new Date(agentStatusInfo.statusDate);
    //         const now = new Date();
    //         const diff = Math.floor((now - statusDate) / 1000); // in seconds
    //
    //         const hours = Math.floor(diff / 3600);
    //         const minutes = Math.floor((diff % 3600) / 60);
    //         const seconds = diff % 60;
    //
    //         const formatted = `${hours.toString().padStart(2, "0")}:${minutes
    //             .toString()
    //             .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    //
    //         setStatusTime(formatted);
    //     };
    //
    //     updateTimer(); // initial run
    //     const interval = setInterval(updateTimer, 1000);
    //     return () => clearInterval(interval); // cleanup on unmount
    // }, [agentStatusInfo?.statusDate]);

    const toggleParentExpand = (id) => {
        setExpandedParents((prevId) => (prevId === id ? null : id));
    };

    const toggleNavigation = () => {
        setIsNavigationExpanded((prev) => !prev);
    };

    const trackMenuClick = async (menuName, url) => {
        const agentid =
            JSON.parse(localStorage.getItem("user"))?.emailaddress || "";
        const agentguid = localStorage.getItem("userguid") || "";
        const now = new Date();
        const year = now.getUTCFullYear();
        const month = String(now.getUTCMonth() + 1).padStart(2, "0");
        const day = String(now.getUTCDate()).padStart(2, "0");
        const hours = String(now.getUTCHours()).padStart(2, "0");
        const minutes = String(now.getUTCMinutes()).padStart(2, "0");
        const seconds = String(now.getUTCSeconds()).padStart(2, "0");
        const milliseconds = String(now.getUTCMilliseconds()).padStart(3, "0");
        const timestampUTC = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
        try {
            await savePageVisits({
                agentid,
                agentguid,
                pageName: menuName,
                pageURL: url,
                visitDate: timestampUTC,
            });
        } catch (error) {
            console.error("Failed to track menu click:", error);
        }
    };

    useEffect(() => {
        if (justLoggedIn === "true" && location.pathname === "/") {
            trackMenuClick("LoggedIn", "/");
            localStorage.setItem("justLoggedIn", "false");
        }
    }, [justLoggedIn, location.pathname]);

    // Render menu recursively
    const RenderMenu = ({ items }) => (
        <List className="ai-navigation-menu__list">
            {items.map((item) => {
                const hasChildren = item.children && item.children.length > 0;
                const isExpanded = expandedParents === item.id;
                const isSelected = activeNode?.id === item.id;
                const isChildActive =
                    !isSelected && activeIds.includes(item.id);
                return (
                    <React.Fragment key={item.id}>
                        <ListItem>
                            <CFNavigationButton
                                to={item.path}
                                onClick={() => {
                                    trackMenuClick(item.name, item.path);
                                    if (hasChildren) {
                                        toggleParentExpand(item.id);
                                    }
                                }}
                                isSelected={isSelected}
                                isChildActive={isChildActive}
                                startIcon={item.icon}
                                itemName={item.name}
                                isNavigationExpanded={isNavigationExpanded}
                                isExpanded={isExpanded}
                                hasChildren={hasChildren}
                            />
                        </ListItem>
                        {hasChildren && isExpanded && (
                            <List disablePadding sx={{}}>
                                {item.children.map((child) => (
                                    <ListItem
                                        key={child.id}
                                        sx={{ pt: 0, pb: 0 }}
                                    >
                                        <CFNavigationButton
                                            to={child.path}
                                            isSelected={
                                                activeNode?.id === child.id
                                            }
                                            isChildActive={
                                                activeNode?.id !== child.id &&
                                                activeIds.includes(child.id)
                                            }
                                            startIcon={child.icon}
                                            itemName={child.name}
                                            isExpanded={isExpanded}
                                            isNavigationExpanded={
                                                isNavigationExpanded
                                            }
                                            onClick={() => {
                                                trackMenuClick(
                                                    child.name,
                                                    child.path
                                                );
                                            }}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        )}
                    </React.Fragment>
                );
            })}
        </List>
    );

    const getAllowedPaths = (menuItems) => {
        const allowedPaths = [];
        const paths = (items) => {
            items.forEach((item) => {
                if (item.children && item.children.length > 0) {
                    item.children.forEach((child) => {
                        if (child.path) {
                            allowedPaths.push(child.path);
                        }
                        if (child.children?.length > 0) {
                            paths(child.children);
                        }
                    });
                }
            });
        };
        paths(menuItems);
        return allowedPaths;
    };

    useEffect(() => {
        const allowedPaths = getAllowedPaths(menuItems);
        setAllowedPaths(allowedPaths);
    }, [menuItems, setAllowedPaths]);

    const theme = useTheme();

    return (
        <Box
            className={`ai-layout ${
                !isNavigationExpanded ? "ai-layout-collapsed" : ""
            }`}
        >
            <Box className="ai-navigation">
                <Box className="ai-navigation-header">
                    <Box className="ai-navigation-header__client">
                        <Avatar
                            variant="rounded"
                            sx={{
                                mr: 2,
                                bgcolor: theme.palette.primary.main,
                                fontSize: ".75rem",
                            }}
                        >
                            {companyName
                                .split(" ")
                                .map((n) => n[0])
                                .join("")}
                        </Avatar>
                        {isNavigationExpanded && <Box>{companyName}</Box>}
                    </Box>
                </Box>

                <Box className="ai-navigation-menu">
                    {menuItems.length === 0 ? (
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ p: 2 }}
                        >
                            Loading menu...
                        </Typography>
                    ) : (
                        <RenderMenu items={menuItems} />
                    )}
                </Box>

                <Box className="ai-navigation-footer">
                    <div className="ai-navigation-footer__actions">
                        <Divider />
                        <Tooltip
                            title={!isNavigationExpanded ? "Expand Menu" : ""}
                            placement="right"
                        >
                            <Button
                                onClick={toggleNavigation}
                                color="info"
                                size="small"
                                fullWidth
                                sx={{
                                    height: "31px",
                                    fontSize: "0.75rem",
                                    ".MuiButton-icon": {
                                        marginRight: isNavigationExpanded
                                            ? "8px"
                                            : 0,
                                    },
                                }}
                                startIcon={
                                    isNavigationExpanded ? (
                                        <MenuOpenIcon />
                                    ) : (
                                        <MenuIcon />
                                    )
                                }
                            >
                                {isNavigationExpanded && "Collapse Menu"}
                            </Button>
                        </Tooltip>
                    </div>
                    <div className="ai-navigation-footer__powered-by">
                        <Logo />
                        {isNavigationExpanded && (
                            <div className="ai-navigation-footer__powered-by--wordmark">
                                <small>Powered by</small>
                                <span>
                                    CaraFin
                                    <span>ai</span>
                                </span>
                            </div>
                        )}
                    </div>
                </Box>
            </Box>

            <Box className="ai-main">
                <Box
                    className="ai-main-toolbar"
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    {/* Breadcrumb: ancestors muted, active page strong. Gives group
                        context that the sidebar loses when it is collapsed. */}
                    <Box
                        sx={{ display: "flex", alignItems: "baseline", gap: 0.75 }}
                    >
                        {activeTrail.map((node, idx) => {
                            const isLast = idx === activeTrail.length - 1;
                            return (
                                <React.Fragment key={node.id}>
                                    {idx > 0 && (
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: theme.palette.text
                                                    .disabled,
                                            }}
                                        >
                                            /
                                        </Typography>
                                    )}
                                    <Typography
                                        variant={isLast ? "h6" : "body2"}
                                        sx={{
                                            color: isLast
                                                ? theme.palette.primary.strong ||
                                                  theme.palette.primary.dark
                                                : theme.palette.text.secondary,
                                            fontWeight: isLast ? 600 : 400,
                                        }}
                                    >
                                        {node.name}
                                    </Typography>
                                </React.Fragment>
                            );
                        })}
                    </Box>
                    {/* [DISABLED] Backlog status bar (Active Agents / Texts / Emails / Chats / VMs / Calls / AI Chats).
                        Re-enable by uncommenting this block + the useBacklogPolling hook + import + destructure above. */}
                    {/*
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Button
                            variant={VARIANTS.CONTAINED}
                            sx={{
                                bgcolor: "#fff",
                                color: theme.palette.primary.light,
                                boxShadow: "none",
                                borderRadius: "0px",
                                border: `3px solid #E6E6E6`,
                                borderRadius: `6px`,
                                "&:hover": {
                                    bgcolor: theme.palette.primary.dark,
                                    color: "#fff",
                                },
                            }}
                        >
                            <Typography variant="body2" component="div">
                                Active Agents:&nbsp;
                                <strong>{backlog.agents ?? 0}</strong>{" "}
                                &nbsp;&nbsp;||&nbsp;&nbsp; Texts:&nbsp;
                                <strong>{backlog.texts ?? 0}</strong>{" "}
                                &nbsp;&nbsp;|| &nbsp;Emails:&nbsp;
                                <strong>{backlog.emails ?? 0}</strong>{" "}
                                &nbsp;&nbsp;|| &nbsp;Chats:&nbsp;
                                <strong>{backlog.chats ?? 0}</strong>{" "}
                                &nbsp;&nbsp;|| &nbsp;VMs:&nbsp;
                                <strong>{backlog.vms ?? 0}</strong>{" "}
                                &nbsp;&nbsp;|| &nbsp;Calls:&nbsp;
                                <strong>{backlog.calls ?? 0}</strong>{" "}
                                &nbsp;&nbsp;|| &nbsp;AI Chats:&nbsp;
                                <strong>{backlog.carachats ?? 0}</strong>
                            </Typography>
                        </Button>
                    </Box>
                    */}

                    {/* Avatar button with logout menu */}
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        {/* [DISABLED] Agent status badge ("Online (HH:MM:SS)" / "Offline (HH:MM:SS)" pill).
                            Re-enable by uncommenting this block + the imports + state + effects above. */}
                        {/*
                        {agentStatusInfo.status && (
                            <>
                                <Button
                                    variant={VARIANTS.CONTAINED}
                                    color={
                                        agentStatusInfo.status ===
                                        STATUS_STRINGS.ONLINE
                                            ? BUTTON_COLORS.SUCCESS
                                            : BUTTON_COLORS.ERROR
                                    }
                                    size={SIZES.SMALL}
                                    onClick={(e) =>
                                        setStatusMenu(e.currentTarget)
                                    }
                                    endIcon={
                                        statusMenu ? (
                                            <ArrowDropUpIcon />
                                        ) : (
                                            <ArrowDropDownIcon />
                                        )
                                    }
                                >
                                    {agentStatusInfo.status}{" "}
                                    {statusTime && `(${statusTime})`}
                                </Button>
                                <Menu
                                    anchorEl={statusMenu}
                                    open={statusMenu}
                                    onClose={() => setStatusMenu(false)}
                                    MenuListProps={{
                                        dense: true,
                                        sx: {
                                            paddingTop: 0,
                                            paddingBottom: 0,
                                        },
                                    }}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                width:
                                                    statusMenu?.offsetWidth ||
                                                    150,
                                                borderRadius: 1,
                                                boxShadow: 2,
                                                py: 0,
                                            },
                                        },
                                    }}
                                    anchorOrigin={{
                                        vertical: "bottom",
                                        horizontal: "left",
                                    }}
                                    transformOrigin={{
                                        vertical: "top",
                                        horizontal: "left",
                                    }}
                                >
                                    {agentStatusInfo.statusInfo?.map(
                                        (info, idx) => (
                                            <MenuItem
                                                key={idx}
                                                onClick={() =>
                                                    setStatusMenu(false)
                                                }
                                            >
                                                {info}
                                            </MenuItem>
                                        )
                                    )}
                                </Menu>
                            </>
                        )}
                        */}
                        <IconButton
                            onClick={handleAvatarClick}
                            size="small"
                            sx={{ ml: 2 }}
                            aria-controls={open ? "account-menu" : undefined}
                            aria-haspopup="true"
                            aria-expanded={open ? "true" : undefined}
                        >
                            <Avatar
                                sx={{
                                    bgcolor: theme.palette.primary.main,
                                    cursor: "pointer",
                                }}
                            >
                                {userInitials}
                            </Avatar>
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            id="account-menu"
                            open={open}
                            onClose={handleCloseMenu}
                            onClick={handleCloseMenu}
                            PaperProps={{
                                elevation: 0,
                                sx: {
                                    mt: 1.5,
                                    overflow: "visible",
                                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                                    "&:before": {
                                        content: '""',
                                        display: "block",
                                        position: "absolute",
                                        top: 0,
                                        right: 14,
                                        width: 10,
                                        height: 10,
                                        bgcolor: "background.paper",
                                        transform:
                                            "translateY(-50%) rotate(45deg)",
                                        zIndex: 0,
                                    },
                                },
                            }}
                            transformOrigin={{
                                horizontal: "right",
                                vertical: "top",
                            }}
                            anchorOrigin={{
                                horizontal: "right",
                                vertical: "bottom",
                            }}
                        >
                            <MenuItem onClick={handleLogout}>Logout</MenuItem>
                        </Menu>
                    </Box>
                </Box>

                <Box className="ai-main-page">
                    <Outlet />
                </Box>

                <Box className="ai-main-footer">
                    <Typography variant="caption">
                        &copy; CaraFin.ai, Financial Services. All Rights
                        Reserved.
                    </Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;